var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartUnpressed = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.591 5.174a3.745 3.745 0 0 0-5.445 0c-1.528 1.586-1.528 4.171 0 5.757l.04.045L12 18.959l6.813-7.983a1.01 1.01 0 0 1 .04-.045c1.529-1.586 1.529-4.171 0-5.757a3.745 3.745 0 0 0-5.444 0L12 6.636zM12 3.754a5.744 5.744 0 0 0-8.294.032c-2.267 2.353-2.275 6.148-.022 8.51L12 22.041l8.316-9.745c2.253-2.362 2.245-6.157-.022-8.51A5.744 5.744 0 0 0 12 3.753Z",
    clipRule: "evenodd"
  })));
};
export default SvgHeartUnpressed;